import { AlertTriangle, Inbox } from "lucide-react";

import { useCraneT } from "../lib/i18n";
import { cn } from "../lib/utils";
import { Button } from "../ui/button";
import { Spinner } from "../ui/spinner";

/** Stany pomocnicze list i tabel. Domyślne teksty pochodzą z i18n —
 *  wywołujący może je nadpisać własnym (już przetłumaczonym) stringiem. */

export interface EmptyStateProps {
  title?: string;
  hint?: string;
  className?: string;
}

export const EmptyState = ({ title, hint, className }: EmptyStateProps) => {
  const t = useCraneT();
  return (
    <div className={cn("flex flex-col items-center gap-2 px-4 py-10 text-center", className)}>
      <Inbox className="size-6 text-crane-muted-foreground" aria-hidden />
      <p className="text-sm font-semibold text-crane-foreground">{title ?? t("common.noResults")}</p>
      {hint ? <p className="text-xs text-crane-muted-foreground">{hint}</p> : null}
    </div>
  );
};

export interface LoadingStateProps {
  label?: string;
  className?: string;
}

export const LoadingState = ({ label, className }: LoadingStateProps) => {
  const t = useCraneT();
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-4 py-10 text-sm text-crane-muted-foreground",
        className,
      )}
    >
      <Spinner size="xl" />
      {label ?? t("commonActions.loading")}
    </div>
  );
};

export interface ErrorStateProps {
  title?: string;
  hint?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState = ({ title, hint, onRetry, className }: ErrorStateProps) => {
  const t = useCraneT();
  return (
    <div className={cn("flex flex-col items-center gap-2 px-4 py-10 text-center", className)}>
      <AlertTriangle className="size-6 text-crane-status-error" aria-hidden />
      <p className="text-sm font-semibold text-crane-foreground">{title ?? t("common.somethingWentWrong")}</p>
      {hint ? <p className="text-xs text-crane-muted-foreground">{hint}</p> : null}
      {onRetry ? (
        <Button variant="outline" size="sm" className="mt-2" onClick={onRetry}>
          {t("common.retry")}
        </Button>
      ) : null}
    </div>
  );
};
